export type SupportedNetworkMode = 'TESTNET' | 'MAINNET';

export const SUPPORTED_NETWORK_MODE: SupportedNetworkMode =
  process.env.VUE_APP_SUPPORTED_NETWORK_MODE === 'development' ? 'TESTNET' : 'MAINNET';
